<!-- 客户到站数据智能统计 -->
<template>
  <div class="nx-list-page">
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page"
      :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen"
      @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad" @selection-change="selectionChange">
      <template slot="menuLeft">
        <el-button type="primary" size="small" plain icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </template>
      <template slot-scope="{row, index}" slot="custName">
        <div class="custName">
          <el-rate :value="1" :max="1" disabled></el-rate>
          <p>{{ row.custName }}</p>
        </div>
      </template>
       <template slot-scope="{row, index}" slot="qualityPer">
         <el-link type="success" :underline="false">{{ row.qualityPer }}%</el-link>
      </template>
    </avue-crud>
  </div>
</template>


<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, exportExcel } from "./api";
import { downloadXls } from '@/util/util'
import {
  getSettingDate
} from "@/util/date";
export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList },
      exportLoading: false,
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        menu: false,
        column: [
          {
            label: '客户',
            prop: 'custNo',
            type: 'select',
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            search: true, // 查询是否显示
            props: {
              label: 'deptName',
              value: 'id'
            },
          },
        //   {
        //     label: '合同计划量',
        //     prop: 'contractWeight',
        //     overHidden: true, // 表格超出隐藏
        //   },
          {
            label: '累计到货量(吨)',
            prop: 'inWeight',
            type: 'number',
            precision: 2,
            min: 0.01,
            max: 99999,
            overHidden: true, // 表格超出隐藏
          },
          {
            label: '当前库存量(吨)',
            prop: 'currentWeight',
            type: 'number',
            precision: 2,
            min: 0.01,
            max: 99999,
            overHidden: true, // 表格超出隐藏
          },
          {
            label: '库存占比',
            prop: 'stockPer',
            overHidden: true, // 表格超出隐藏
          },
        //   {
        //     label: '质检合格率',
        //     prop: 'qualityPer',
        //     overHidden: true, // 表格超出隐藏
        //   },
          {
            label: '搜索时间',
            prop: 'queryDate',
            search: true, // 查询是否显示
            type: "datetime",
            hide: true,
            showColumn: false,
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            viewDisplay: false,
            addDisplay: false,
            editDisplay: false,
            searchValue: getSettingDate('now',{format: 'YYYY-MM-DD'}),
          },
        ]
      },
    }
  },
  methods: {
    async handleExport () {
      if ((this.page.total || 0) < 1) {
        this.$message.warning('无数据可导出')
        return
      }
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `客户到站统计_${Date.now()}.xlsx`)
        if (this.page.total > 10000) {
          this.$message.warning(`仅导出前 10000 条，共 ${this.page.total} 条`)
        } else {
          this.$message.success('导出成功')
        }
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exportLoading = false
      }
    }
  }
}
</script>
<style scoped lang="scss">
p {
  margin: 0;
}

.custName {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
</style>
